import React from 'react'
import Email from './Email'

import './AdvisorSmall.css'

const AdvisorSmall = ({ name, phone, email }) => (
  <div className="advisor-small">
    <div className="content">
      <h3>{name}</h3>
      <div className="phone">{phone}</div>
      <Email email={email} label="Send e-post" />
    </div>
  </div>
)

export default AdvisorSmall
